{
  "GENERAL": {
    "CLOSE": "Sluiten",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Zoeken",
      "EMPTY_STATE": "Geen resultaten gevonden"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Ten minste {count} vereist"
  }
}
